import type { ContactStatus } from "@ai-leasing-os/shared";
import { Badge } from "@/components/ui/badge";

const VARIANT: Record<ContactStatus, "default" | "muted" | "success" | "warning" | "danger" | "info"> = {
  prospect: "muted",
  lead: "default",
  qualified: "info",
  viewing_scheduled: "info",
  visited: "info",
  negotiation: "warning",
  deposit_pending: "warning",
  client: "success",
  lost: "danger",
};

const LABEL: Record<ContactStatus, string> = {
  prospect: "Prospect",
  lead: "Lead",
  qualified: "Qualified",
  viewing_scheduled: "Viewing",
  visited: "Visited",
  negotiation: "Negotiation",
  deposit_pending: "Deposit",
  client: "Client",
  lost: "Lost",
};

export function StatusBadge({ status }: { status: ContactStatus }) {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>;
}
